import React from 'react';
import styled from 'styled-components';
import { AccountIcons, useAccountStore } from '@components/dashboard/context/UserDashboardContext';
import Colors from '@components/shared/Colors';
import { PROFILE_AFRO_SVG, PROFILE_BUN_SVG, PROFILE_LONGHAIR_SVG, PROFILE_MEDIUMHAIR_SVG, PROIFLE_SHORTHAIR_SVG } from '@constants';

interface Props {
  icon: string;
}

const AccountIcon: React.FC<Props> = ({ icon }) => {
  const userInfo = useAccountStore((accountState) => accountState.userInfo);

  const getInitialsOrDefault = () => {
    if (userInfo.firstName && userInfo.lastName) {
      const firstLetter = userInfo.firstName[0]?.toUpperCase();
      const secondLetter = userInfo.lastName[0]?.toUpperCase();
      return firstLetter + secondLetter;
    }
    if (userInfo.email) {
      return userInfo.email[0]?.toUpperCase();
    }
    return <img src={PROFILE_MEDIUMHAIR_SVG} alt="Medium Hair" />;
  };

  switch (icon) {
    case AccountIcons.ShortHair:
      return <img src={PROIFLE_SHORTHAIR_SVG} alt="Short Hair" />;
    case AccountIcons.MediumHair:
      return <img src={PROFILE_MEDIUMHAIR_SVG} alt="Medium Hair" />;
    case AccountIcons.LongHair:
      return <img src={PROFILE_LONGHAIR_SVG} alt="Long Hair" />;
    case AccountIcons.Bun:
      return <img src={PROFILE_BUN_SVG} alt="Bun" />;
    case AccountIcons.Afro:
      return <img src={PROFILE_AFRO_SVG} alt="Afro" />;
    case AccountIcons.Initials:
    default:
      return <Initials>{getInitialsOrDefault()}</Initials>;
  }
};

export default AccountIcon;

const Initials = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background: ${Colors.navyBlue};
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 15px;
  font-weight: 700;
  font-family: 'BrownStd';
  color: ${Colors.cream};
`;
